import React, { Component } from "react";
import { Text, Box, Divider, HStack, Spacer, Tag, toVarDefinition } from '@chakra-ui/react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faXmark, faCalculator, faClose, faFileUpload, faImagePortrait, faImages, faCheck, faCamera } from "@fortawesome/free-solid-svg-icons";



import BaseDisplay from "./BaseDisplay";

import ReadOnlyInput from "./ReadOnlyInput";
import DropdownInput from "./DropdownInput";
import TextInput from "./TextInput";
import CountInput from "./CountInput";
import MultiEntryIQueueApiLookupInput from "./MultiEntryIQueueApiLookupInput";
import MultiEntryApiLookupInput from "./MultiEntryApiLookupInput";
import MultiEntryApiLookupDisplay from "./MultiEntryApiLookupDisplay";
import DateInput from "./DateInput";
import BasketQuantityCountInput from "./BasketQuantityCountInput";
import CompositeCountInput from "./CompositeCountInput";
import CompositeCountDisplay from "./CompositeCountDisplay";
import TextEditInput from "./TextEditInput";
import LookupEntityInput from "./LookupEntityInput";
import MultiEntryInput from "./MultiEntryInput";
import MultiEntryDisplay from "./MultiEntryDisplay";
import MultiEntryKeyPairInput from "./MultiEntryKeyPairInput";
import MultiEntryKeyPairDisplay from "./MultiEntryKeyPairDisplay";
import UserDocDisplay from "./UserDocDisplay";
import UserImageDisplay from "./UserImageDisplay";
import CheckListCardInput from "./CheckListCardInput-2";
import TextParserMapInput from "./TextParserMapInput";
import CheckListBoxInput from "./CheckListBoxInput";


const cardBodyColors = {
    default: "#0a597e",
    required: "#B63935",
    readonly: "#c9c7c6"
}

export default class BaseCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardState: "untouched",
            cardValue: this.props.valueBag[this.props.card.id],
            required: (this.props.card?.validation?.required),
            cardTitleColor: 'white'
        };

        this.id = this.props.card.id;

        this.getCardState = this.getCardTouchedState.bind(this);
        this.getCard = this.getActiveCard.bind(this);
        this.getTouchedCard = this.getTouchedCard.bind(this);
        this.onValueChange = this.onValueChange.bind(this);

        this.onCardClick = this.onCardClick.bind(this);
        this.onLoseFocus = this.onLoseFocus.bind(this);
        

        this.onCardTitleEnter = this.onCardTitleEnter.bind(this);
        this.onCardTitleExit = this.onCardTitleExit.bind(this);

    }

    componentDidMount() 
    {
        // when it mounts it should NEVER be active.
        var initTouchedState = this.getCardTouchedState(this.props.card);
        this.setState({cardState: initTouchedState});
    }


    componentDidUpdate(prevProps, prevState)
    {
        let oldVal = prevState.cardValue;
        //console.log("valueBag: ");
        //console.log(this.props.valueBag);
        let newVal = this.props.valueBag[this.id];
        //console.log("Id: " + this.id + " Old: " + oldVal + " New: " + newVal);
        if (oldVal !== newVal) {
            this.setState({
                cardValue: newVal
            });
            if (this.state.cardState !== "active") 
            {
                var newTouchedState = this.getCardTouchedState(this.props.card);
                this.setState({cardState: newTouchedState});
            }
        }
    }

    getCardTouchedState(card)
    {
        var result;
        if (!card.arrayValue)
        {
            result = (this.props.valueBag[card.id]) ? "touched" : "untouched";
        }
        else
        {
            // a little more complicated. We have an array of values. we need to find the proper card value inside the ARRAY
            // inside the valueBag
            let ourValueArray = this.props.valueBag[card.parentId];
            result = (ourValueArray.some((r) => r.id === card.id)) ? "touched" : "untouched";
        }

        return result;
    }

    getTouchedCard(card) 
    {
        switch (card.fieldType) {
            case "containerqtyproduct": return <CompositeCountDisplay card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue}/>
            case "containerbasketqtyproduct": return <CompositeCountDisplay card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue}/>

            case "multiinput": return <MultiEntryDisplay cardValue={this.state.cardValue} />
            // note that we use the same display for the api lookup as for the multi-entry 
            case "multientryapilookup": return <MultiEntryDisplay cardValue={this.state.cardValue} />
            case "multientryiqueueapilookup": return <MultiEntryDisplay cardValue={this.state.cardValue} />
            case "multientrykeypair": return <MultiEntryKeyPairDisplay card={card} cardValue={this.state.cardValue} />
            case "userimage": return <UserImageDisplay card={card} gcid={this.props.userSession.gcid} valueBag={this.props.valueBag} onValueChange={this.onValueChange} removeSchemaCard={this.props.removeSchemaCard} onMsgBoxRequest={this.props.onMsgBoxRequest} observationSessionMode={this.props.observationSessionMode}/>
            case "userdoc": return <UserDocDisplay card={card} gcid={this.props.userSession.gcid} valueBag={this.props.valueBag} onValueChange={this.onValueChange} removeSchemaCard={this.props.removeSchemaCard} onMsgBoxRequest={this.props.onMsgBoxRequest} observationSessionMode={this.props.observationSessionMode}/>
            default: return <BaseDisplay card={card} cardValue={this.state.cardValue} />
        }
    }

//+++++++++++++++++++++ FOR TESTING ADDING THE NEW PALLET CARD OVERRIDE TO THE READONLYS +++++++++++++++++++++++++++++++++++++++++++++++++++++
    getActiveCard(card) {
        switch (card.fieldType) 
        {
            case "multientryiqueueapilookup": return <MultiEntryIQueueApiLookupInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} schemaId={this.props.schema.schemaInfo.id} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onlineInfo={this.props.onlineInfo}/>
 
            case "multientryapilookup": return <MultiEntryApiLookupInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onlineInfo={this.props.onlineInfo}/>
 
            case "textparsermap": return <TextParserMapInput card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} />
            case "checklistcard": return <CheckListCardInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onlineInfo={this.props.onlineInfo}/>
            case "dropdown": return <DropdownInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} />
            case "text": return <TextInput card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} />
            case "readonly": return <ReadOnlyInput card={card} valueBag={this.props.valueBag} />
            case "multientrykeypair": return <MultiEntryKeyPairInput card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue} onValueChange={this.onValueChange}/>
            case 'date': return <DateInput card={card} cardValue={this.state.cardValue} onValueChange={this.onValueChange} />
            case "multiinput": return <MultiEntryInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} cardValue={this.state.cardValue}/>
            case "containerqtyproduct": return <CompositeCountInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} cardValue={this.state.cardValue} onValidationChange={this.props.onValidationChange} />
            case "containerbasketqtyproduct": return <BasketQuantityCountInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} cardValue={this.state.cardValue} onValidationChange={this.props.onValidationChange} />
            case "checklistbox": return <CheckListBoxInput card={card} valueBag={this.props.valueBag} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onlineInfo={this.props.onlineInfo}/>
            case "texteditor": return <TextEditInput card={card} cardValue={this.state.cardValue} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onlineInfo={this.props.onlineInfo}/>
            case "lookupentity": return <LookupEntityInput schema={this.props.schema} card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue} onValueChange={this.onValueChange} gcid={this.props.userSession.gcid} token={this.props.userSession.token} onSaveLookupEntity={this.props.onSaveLookupEntity} onRemoveLookupEntity={this.props.onRemoveLookupEntity} lookupEntityBag={this.props.lookupEntityBag} onlineInfo={this.props.onlineInfo}/>
            default: return <CountInput card={card} valueBag={this.props.valueBag} cardValue={this.state.cardValue} onValueChange={this.onValueChange} />
        }
    }



    onCardClick(ev) {
        console.log(ev)
        // var newState = (this.state.cardState === "active") ?
        //     (this.state.cardValue) ? "touched" : "untouched"
        //     : "active";
        if (this.props.card?.disallowToggle) return;
        var newState;
        if (this.state.cardState === "active") {
            if (this.state.cardValue) {
                newState = "touched"
            } else {
                newState = "untouched"
            }
        } else {
            newState = "active"
        }


        console.log(newState)
        this.setState({ cardState: newState }, () => {
            console.log(this.state.cardState)
        }
        );
        console.log("now:")
        console.log(this.state.cardState)
        this.props.onToggleCard(this);
    }

    onLoseFocus() {
        var newCardState = (this.state.cardValue) ? "touched" : "untouched";
        this.setState({ cardState: newCardState });
    }

    onValueChange(newValue, valueBagId, changeThisCard = true) 
    {
        if (changeThisCard)
        {
            // we are changing the value of THIS card, so change the cardValue. 
            this.setState({ cardValue: newValue });
        }
        this.props.onValueChange((valueBagId) ? valueBagId : this.id, newValue);
    }

    onCardTitleEnter() {
        console.log(this.props.card.id)
        this.setState({
            cardTitleColor: 'gray'
        })
    }

    onCardTitleExit() {
        this.setState({
            cardTitleColor: 'white'
        })
    }



    untouchedState() 
    {
        // var bodyColor = this.state.required ? cardBodyColors['required'] : cardBodyColors['default']

        var titleDisplay = (this.props.card.label) ? this.props.card.label : this.props.card.title;
        var bodyColor;
        if(this.state.required){
            bodyColor = cardBodyColors['required']
        } else {
            bodyColor = cardBodyColors['default']
        }

        return (
            <Box style={{ boxShadow: 'dark-lg', backgroundColor: bodyColor, borderRadius: '5px', padding: "10px", minWidth: '50%', borderColor: 'gray' }} >
                <HStack>
                    <Text
                        fontSize={{ base: '14px', md: '20px', lg: '24px' }}
                        color={this.state.cardTitleColor}
                        margin='0'
                        onMouseEnter={(e) => this.onCardTitleEnter()}
                        onMouseLeave={(e) => this.onCardTitleExit()}
                        onClick={(e) => this.onCardClick(e)}
                    >
                        {titleDisplay}
                    </Text>
                    <Spacer />
                </HStack>
                <Divider />

            </Box>
        );
    }


    touchedState() 
    {
        var titleDisplay = (this.props.card.label) ? this.props.card.label : this.props.card.title;
        var bodyColor;
        if(this.props.card.fieldType === 'readonly'){
            bodyColor = cardBodyColors['readonly']
        } else {
            bodyColor = cardBodyColors['default']
        }
        return (
            <Box style={{ backgroundColor: bodyColor, borderRadius: '5px', padding: "10px", minWidth: (this.props.card.fieldType === "userimage") ? '' : "50%", borderColor: (this.state.required) ? 'lightgreen' : 'gray' }} onClick={this.onCardClick}>
                <HStack>
                    <Text
                        fontSize={{ base: '14px', md: '20px', lg: '24px' }}
                        color={(this.props.card.fieldType === 'readonly') ? "gray": this.state.cardTitleColor}
                        margin='0'
                        onMouseEnter={(e) => this.onCardTitleEnter()}
                        onMouseLeave={(e) => this.onCardTitleExit()}
                        onClick={(e) => this.onCardClick(e)}
                    >
                        {titleDisplay}
                    </Text>
                </HStack>
                <Spacer/>
                <Divider />
                {this.getTouchedCard(this.props.card)}
            </Box>
        );
    }

    activeState() 
    {
        var titleDisplay = (this.props.card.label) ? this.props.card.label : this.props.card.title;
        return (

            <Box style={{ backgroundColor: "#0a597e", borderRadius: '5px', padding: "10px", minWidth: '50%', borderColor: (this.state.required) ? 'red' : 'gray' }} >
                <HStack>
                    <Text
                        fontSize={{ base: '14px', md: '20px', lg: '24px' }}
                        color={this.state.cardTitleColor}
                        margin='0'
                        onMouseEnter={(e) => this.onCardTitleEnter()}
                        onMouseLeave={(e) => this.onCardTitleExit()}
                        onClick={(e) => this.onCardClick(e)}
                    >
                        {titleDisplay}
                    </Text>
                    <Spacer />
                    {(this.props.card.criteriaSlides) &&
                        <FontAwesomeIcon size="lg" icon={faImages} color='white' onClick={() => this.props.onShowCardSlides(this.props.card.criteriaSlides)} />
                    }

                    {(!this.props.card.fieldType) &&
                    <FontAwesomeIcon size="lg" icon={faCalculator} color='white' onClick={() => this.props.onShowCalculator(true)} />
                    }
                    <FontAwesomeIcon size="lg" icon={faCamera} color='white'  onClick={() => this.props.onShowUserImages(true)} />
                </HStack>
                <Divider />
                {this.getActiveCard(this.props.card, this.props.valueBag)}
            </Box>
        )
    }

    renderState() 
    {
        switch (this.state.cardState) 
        {
            case "untouched":
                return this.untouchedState();
            case "touched":
                return this.touchedState();
            default:
                return this.activeState();
        }
    }

    render() {
        return this.renderState();
    }
}
